import appJSON from '../.application.json';

import componentJSON from './components/AiAssistantWidget/.component.json';

export const APP_DEFINITION_ID = appJSON.appDefinitionId;
export const WIDGET_ID = componentJSON.id;
export const ONE_CHAT_HELP_ID = '0f639fa9-c140-4c6f-a258-a6dc6df21cac';
export const ONE_CHAT_HELP_ID_SETTINGS = '200eb254-867f-49e4-855a-ec4c6bcb1fea';
export const ONE_CHAT_HELP_ID_SETTINGS_SUPPORT =
  'a7220857-3c06-4ee6-84cf-ff27331b7e60';
export const DEFAULT_WIDGET_POSITION = 'right';

export const WIX_CHAT_APP_DEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2';

export const BM_ROOT = 'wix-ai-assistant-client';
export const BM_PLAYGROUND = `${BM_ROOT}/playground`;
export const BM_SETTINGS = `${BM_ROOT}/settings`;
export const BM_QUOTA = `${BM_ROOT}/quota-usage`;

export const INBOX_BM_PAGE_ID = 'inbox';
export const PRESENCE_METADATA_URL =
  '_serverless/presence-api-metadata/v1/metadata';

export const BREAKPOINTS_HELP_ID = '96cc4dba-5cd6-4f7e-9fe0-6454e860b4c0';

// Session/Local storage keys:
export const SS_FORCE_EXPAND_IN_VIEWER = 'forceExpandedInViewer';
export const SS_NAVIGATION_PAYLOAD = 'NavigationPayload';
export const SS_NAVIGATION_REPORTS = 'NavigationRepots';
export const SS_VISUAL_LAYOUT_STATE = 'VisualLayoutState';
export const SS_ENGAGE_MESSAGE_SHOWN = 'EngageMessageShown';
export const SS_SUGGESTION_CHIPS_SHOWN = 'SuggestionChipsShown';
export const SS_REPORTED_NEW_VISITOR = 'ReportedNewVisitor';

export const EDITOR_SDK_PUBLIC_DATA_KEY = 'EditorSDKPublicData';

export const GIVE_FEEDBACK_URL = 'https://wix-ai-site-chat.com';

export const A11Y_CHAT_DIALOG_ID = 'a11y-ai-assistant-dialog';

export const EXPERIMENTS = {
  GIVE_FEEDBACK_BUTTON: 'specs.aiAssistant.giveFeedbackButton',
  RENDER_AI_MESSAGE_OPTIONS: 'specs.aiAssistant.renderAiMessageOptions',
  INTRO_CHIPS: 'wixSmartChatChips2',
  REPORT_NEW_VISITOR: 'smartChatReportNewVisitor',
  REPORT_NEW_VISITOR_EVERY_5_MIN: 'smartChatReportNewVisitorEvery5Min',
  SKIP_LEGAL_NOTIFICATION: 'smartChatSkipLegalNotification',
  STREAM_MESSAGE_RESPONSES: 'aiAssistantWidgetStreamMessage',
} as const;
